/* Publish by EComposer at 2024-07-17 21:44:23*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2sitlukcc24"]=  window.__ectimmers["ecom-2sitlukcc24"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-2sitlukcc24').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2sitlukcc24', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-psm60j8qu2n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-psm60j8qu2n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6fhymfdtk9s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6fhymfdtk9s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kkwxbjo25c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kkwxbjo25c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-93jov7i6zr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-93jov7i6zr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h4g8owyfxkv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h4g8owyfxkv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5nhcekr98dr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5nhcekr98dr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5jbnuqmpab').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5jbnuqmpab', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2q3t4nf2g4x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2q3t4nf2g4x', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-sltdve7inyh"]=  window.__ectimmers["ecom-sltdve7inyh"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-sltdve7inyh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sltdve7inyh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-66o4xt4b97m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-66o4xt4b97m', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-87jzx0exhzm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-87jzx0exhzm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4b8oyisnmqg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4b8oyisnmqg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}